import { useCallback, useMemo, useState } from 'react';

import { continueDocumentReaderRun } from '@commenda/api/commenda-ai/document-reader/continueDocumentReaderRun';
import { useDocumentReaderRun } from '@commenda/api/commenda-ai/document-reader/useDocumentReaderRun';

import {
  DocumentReadingRunHelper,
  type IDocumentReadingRunCardView,
} from './DocumentReadingRunHelper';

export function useDocumentReadingRunCard(runId: string): {
  cardView: IDocumentReadingRunCardView | null;
  isLoading: boolean;
  error: unknown;
  isApproving: boolean;
  approveError: string | null;
  approveRun: () => Promise<void>;
} {
  const { run, isLoading, error, refreshRun } = useDocumentReaderRun(runId);
  const [isApproving, setIsApproving] = useState(false);
  const [approveError, setApproveError] = useState<string | null>(null);

  const cardView = useMemo(
    () => (run ? DocumentReadingRunHelper.getCardView(run) : null),
    [run]
  );

  const approveRun = useCallback(async () => {
    setIsApproving(true);
    setApproveError(null);
    const result = await continueDocumentReaderRun(runId);
    if (!result.success)
      setApproveError(result.error ?? 'Could not start the reading.');
    await refreshRun();
    setIsApproving(false);
  }, [runId, refreshRun]);

  return {
    cardView,
    isLoading,
    error,
    isApproving,
    approveError,
    approveRun,
  };
}
